import { Link, useLocation, useNavigate } from 'react-router-dom';
import api from '../../../../api/axios';
import { logout } from '../../../../store/slices/authSlice';
import { useLoading } from '../../../../components/LoadingProvider';
import { getPublicImgUrl } from '../../../../utils/common';
import { useDispatch } from 'react-redux';

export default function HospitalProfileSidebar({ user, role, profileData }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setIsLoading } = useLoading();

    // Handle logout function
    const handleLogout = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await api.post(`/${role}/logout`);
            dispatch(logout());
            navigate('/login');
        } catch (error) {
            dispatch(error.response?.data?.message || 'Failed to Logout. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-column align-items-center text-center">
                        <img src={profileData?.profile_picture || user?.profile_picture || (getPublicImgUrl()+'/profile_8747415.png')} alt="user" className="img-fluid p-1 bg-primary rounded-2" width="110" />
                        <div className="mt-3">
                            <h4>{user?.name}</h4>
                            <p className="text-secondary mb-1"><b>{user?.phone_code} {user?.phone_number}</b></p>
                            <p className="text-muted font-size-sm"><b>{user?.email}</b></p>
                        </div>
                    </div>
                    <div className="list-group list-group-flush text-center mt-4">
                        <Link
                            to="/dashboard/hospital/profile"
                            className={`list-group-item list-group-item-action border-0 rounded-2 ${location.pathname === '/dashboard/hospital/profile' ? 'active' : ''}`}
                        >Profile Information</Link>
                        <Link
                            to="/dashboard/hospital/appointment/book"
                            className={`list-group-item list-group-item-action border-0 rounded-2 ${location.pathname === '/dashboard/hospital/appointment/book' ? 'active' : ''}`}
                        >Book Appointment</Link>
                        <Link
                            to="/dashboard/hospital/patients"
                            className={`list-group-item list-group-item-action border-0 rounded-2 ${location.pathname === '/dashboard/hospital/patients' ? 'active' : ''}`}
                        >Patients</Link>
                        <Link
                            to="/dashboard/hospital/team-members"
                            className={`list-group-item list-group-item-action border-0 rounded-2 ${location.pathname === '/dashboard/hospital/team-members' ? 'active' : ''} d-none`}
                        >Team Members</Link>
                        <Link
                            to=""
                            onClick={handleLogout}
                            className={`list-group-item list-group-item-action border-0 rounded-2`}
                        >Logout</Link>
                    </div>
                </div>
            </div>
        </>
    );
}
